<template>
  <v-layout row>
    <v-dialog max-width="500px" v-model="inputBox" content-class="honey-popup">
      <v-btn flat icon slot="activator">
        <v-icon medium>date_range</v-icon>
      </v-btn>
      <v-toolbar dense card>
        <div class="text-lg-left beez-bold ">
          Pick Date / Time
        </div>
        <v-spacer></v-spacer>
        <v-btn flat icon @click="inputBox = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-title>
          <span class="subheading"
            >Selected Date Time: "{{ dateTimeString }}"</span
          >
        </v-card-title>
        <v-tabs grow v-model="tab">
          <v-tabs-slider color="secondary"></v-tabs-slider>
          <v-tab :key="datePicker">
            <div class="beez-bold  text-capitalize">Pick Date</div>
          </v-tab>
          <v-tab :key="timePicker">
            <div class="beez-bold  text-capitalize">Pick Time</div>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item :key="datePicker">
            <v-card align-center>
              <v-container>
                <v-layout align-center justify-center row>
                  <v-flex xs12 v-if="showDatePicker">
                    <v-date-picker
                      v-model="simpleDate"
                      color="secondary"
                    ></v-date-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="timePicker">
            <v-card align-center>
              <v-container>
                <v-layout align-center justify-center row>
                  <v-flex xs12 v-if="showTimePicker">
                    <v-time-picker
                      v-model="simpleTime"
                      color="secondary"
                    ></v-time-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-btn class="secondary text-capitalize" @click="onSubmit">
            Submit
          </v-btn>
          <v-btn class="text-capitalize" @click="inputBox = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      inputBox: false,
      simpleDate: null,
      simpleTime: null,
      tab: null,
      datePicker: 'datePicker',
      timePicker: 'timePicker'
    }
  },
  mounted() {
    this.simpleDate = moment().format('YYYY-MM-DD')
    this.simpleTime = moment().format('HH:mm')
  },
  props: {
    dateFormat: String,
    showTimePicker: {
      type: Boolean,
      default() {
        return true
      }
    },
    showDatePicker: {
      type: Boolean,
      default() {
        return true
      }
    },
    useSeconds: {
      type: Boolean,
      default() {
        return true
      }
    }
  },

  computed: {
    dateTimeString: {
      get: function() {
        let mdf = moment(this.simpleDate, 'YYYY-MM-DD').format('MMMM Do YYYY')
        let mt = moment(this.simpleTime, 'HH:mm').format('h:mm:ss a')
        return mdf + ', ' + mt
      }
    },
    dateTime: {
      get: function() {
        return moment(this.dateTimeString, 'MMMM Do YYYY, h:mm:ss a').format()
      }
    }
  },
  methods: {
    onSubmit: function() {
      this.$emit('submit', this.dateTime)
      this.inputBox = false
    }
  }
}
</script>

<style scoped></style>
